import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import { useIsAuthenticated } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { Redirect, useLocation } from "react-router-dom";
import { BOLAPICall } from "../../actions/SignIn";
import Loader from "../../components/shared/loader/Loader";
import { setLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { setLangCode } from "../../utils/Internationalization/handleAppInternationalization";
import Profile from "../../components/profile/profile";
import { USER_LANGUAGE_CODE_TYPE, LOCALSESSIONDATAKEYS, SIGNUPTYPE } from "../../constants/AppConstants";
import ErrorPage from "../../components/shared/errorPage/ErrorPage";
import { AzureADB2CSignInRedirect } from "../../utils/Authentication/Azure/MSALInstanceInit";
import { WebCustomerRoutePaths } from "../../constants/Routes";
import { 
    getNativeAppQueryParamsValuesByKey, 
    isDesktopOrBmcClient, 
    isNativeAppRequestWithRedirectURI 
} from "../../constants/AppMethod";
import PostLoginProcessHandler from "../NativeApp/PostLoginProcessHandler";

const MobileHome = (props) => {
    const  loginToken = props?.loginToken || getNativeAppQueryParamsValuesByKey("login_token") || null;
    const  UID = props?.UID || getNativeAppQueryParamsValuesByKey("userid") || null;
    const  deviceid= props?.deviceid || getNativeAppQueryParamsValuesByKey("deviceid") || null;
    const  language = props?.language || getNativeAppQueryParamsValuesByKey("language") || null;
    const  country = props?.country || getNativeAppQueryParamsValuesByKey("country") || null;
    const { inProgress } = useMsal();
    const location = useLocation();
    const dispatch = useDispatch();
    const isAuthenticated = useIsAuthenticated();
    const domain = window.location.href;
    const BOLDetails = useSelector(state => state.BOLAPI);
    const [BOLAPICallStatus, setBOLAPICallStatus] = useState(true);
    const MULTIPLE_ATTEMPT_ERR_CODE = "AADB2C90157";
    const [signupType, setSignupType] = useState(SIGNUPTYPE.MOBILE);
    const isDesktopOrBmcClientApp = isDesktopOrBmcClient();
    const isNativeAppRequest = isNativeAppRequestWithRedirectURI();

    useEffect(() => {
        // Dispatch event after setting Bearer token immediately after login
        if(inProgress === InteractionStatus.None && !isAuthenticated ){
            if(
                (domain.includes('?') && loginToken && country && language && BOLAPICallStatus)
                || (isDesktopOrBmcClientApp && loginToken)
            ){
                dispatch(BOLAPICall(loginToken, location?.pathname));
                setBOLAPICallStatus(false);
                if(country){
                    setLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE, country.toUpperCase());
                }
                if(language){
                    setLangCode(language, USER_LANGUAGE_CODE_TYPE);
                }
            } else if (domain.includes('?') && UID && deviceid && language && country){
                setLocalSessionData(LOCALSESSIONDATAKEYS.UID, UID);
                setLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID, deviceid);
                if(country){
                    setLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROCTRYCODE, country.toUpperCase());
                }
                if(language){
                    setLangCode(language, USER_LANGUAGE_CODE_TYPE);
                }
                AzureADB2CSignInRedirect();
            } else{
                AzureADB2CSignInRedirect();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inProgress]);

    useEffect(() => {
        /** set signup type to MOBILE if user navigates from MobileConnect APP via Shenlong redirect url
         * If not, set signup type to Landingpage_Login 
         */
        if ((domain.includes('?') && UID && deviceid && language && country)) {
            setSignupType(SIGNUPTYPE.MOBILE);
        } else {
            setSignupType(SIGNUPTYPE.LANDINGPAGE_LOGIN);
        }
    }, [UID, country, deviceid, domain, language]);

    /**
     * Condition to handle cancel and multiple attempt error
     * ADB2C new account registration for web signup
     */
    if  (
            location.hash.includes('error') 
            && location.hash.split("%7c")[1] === SIGNUPTYPE.WEB
        ) {
        if (location.hash.includes(MULTIPLE_ATTEMPT_ERR_CODE)) {
            return <Redirect to={WebCustomerRoutePaths.MULTIPLE_ATTEMPT_ERROR}></Redirect>
        } else {
            return <Redirect to={WebCustomerRoutePaths.SELECT_PRINTER}></Redirect>
        }
    }
 
    if(BOLDetails.loader){
        return <Loader></Loader>
    }
    if(BOLDetails.error){
        return <ErrorPage errorInfo={BOLDetails.error}></ErrorPage>
    }
    if(BOLDetails.success){
        AzureADB2CSignInRedirect();
    }
    
    return (
        <>  <UnauthenticatedTemplate>
                <Loader></Loader>
            </UnauthenticatedTemplate>
            <AuthenticatedTemplate>
            { 
                (isNativeAppRequest) 
                ? <PostLoginProcessHandler /> 
                : <Profile signupType={signupType} />
            }
            </AuthenticatedTemplate>
        </>
    )
}

export default MobileHome;